// extracted by mini-css-extract-plugin
export default {"sportIcon":"EventTitle_sportIcon--nY1","sportName":"EventTitle_sportName--RRo","tournament":"EventTitle_tournament--xGE","container":"EventTitle_container--q1v"};